import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';

import { IUserPrefsState } from './state';
import { FeatureName } from './feature';


export const selectState: MemoizedSelector<object, IUserPrefsState> = createFeatureSelector<IUserPrefsState>(FeatureName);
